import React from 'react';
import type { ImageAsset, ImageCrop, ImageHotspot } from '@sanity/types';
import { Image } from '@/components';
import { cn } from '@/lib/utils';

interface MaskedImageProps {
  image: {
    asset: ImageAsset;
    crop?: ImageCrop;
    hotspot?: ImageHotspot;
  };
  mask: string;
  className?: string;
  showStroke?: boolean;
  alt?: string;
  width?: number;
}

const MaskedImage: React.FC<MaskedImageProps> = ({
  image,
  mask,
  className = '',
  alt,
  showStroke = false,
  width,
}) => {
  const RenderedImageWrapper = () => (
    <div className={`masked-image ${mask}`}>
      <Image
        image={image}
        alt={alt}
        width={width}
        className={cn(
          'object-cover object-center transition-transform duration-200 group-hover:scale-105',
          className,
        )}
      />
    </div>
  );

  return (
    <>
      {showStroke ? (
        <div className={`masked-image mask-border ${mask}`}>
          <RenderedImageWrapper />
        </div>
      ) : (
        <RenderedImageWrapper />
      )}
    </>
  );
};

export default MaskedImage;
